module.exports = __webpack_public_path__ + "45f68c19d3dc6bb0821aa5145ac141d1.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/logo-codeup.png
// module id = 997
// module chunks = 2